import React from 'react';

import { IRemoteAgentConnectionStatus } from '~src/settings/bridge-settings/serverApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from '~src/settings/FormikWrapperForStubbing';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';

import { SiteBridgeSettingsForSiteAdminProps } from '../../BridgeSiteSettings';
import { REMOTE_AGENTS_FIELD } from '../bridgeRemoteAgents/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from '../bridgeRemoteAgents/BridgeRemoteAgentsSectionHeaders';
import { BridgeRemoteAgentsTableRow } from '../bridgeRemoteAgents/BridgeRemoteAgentsTableRow';
import { PoolAssignmentOption } from '../types/PoolAssignmentOption';
import { PoolID } from '../types/PoolID';
import { multiPoolTableStyle } from './BridgeMultiPoolSection';

export type MultiPoolTableEntryAgentsProps = Readonly<{
  agents: IRemoteQueryAgent[];
  connectionStatuses: IRemoteAgentConnectionStatus[];
  poolOptions: ReadonlyArray<PoolAssignmentOption>;
  siteId: string;
  agentPoolId: PoolID;
  refreshEdgePools: () => void;
}>;

export function BridgeMultiPoolTableEntryAgents(props: MultiPoolTableEntryAgentsProps) {
  const formik = useFormikContext<SiteBridgeSettingsForSiteAdminProps>();

  return (
    <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
      <BridgeRemoteAgentsSectionHeaders isDefaultPool={true} />

      <tbody>
        <FieldArray
          name={REMOTE_AGENTS_FIELD}
          render={(arrayHelpers: FieldArrayRenderProps) => (
            props.agents.map((agent: IRemoteQueryAgent, index: number) => (
              <tr key={index}>
                <BridgeRemoteAgentsTableRow
                  agent={agent}
                  index={index}
                  connectionStatuses={props.connectionStatuses}
                  arrayHelpers={arrayHelpers}
                  poolTestId={''}
                  isDefaultPool={true}
                  formik={formik}
                  poolOptions={props.poolOptions}
                  siteId={props.siteId}
                  agentPoolId={props.agentPoolId}
                  refreshEdgePools={props.refreshEdgePools}
                />
              </tr>))
          )}
        />
      </tbody>
    </table>
  );
}
